import axios from 'axios';
import { getToken } from '@/utils/auth';

var exportFile = axios.create({
  baseURL: process.env.BASE_API,
  method: 'get',
  timeout: 0,
  responseType: 'blob',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

exportFile.interceptors.request.use((config) => {
  config.headers['Authorization'] = getToken();
  if (!config.data) {
    config.data = {};
  }
  return config;
});

export default exportFile;



// WEBPACK FOOTER //
// ./src/utils/export.js